/** @jsx jsx */
import PropTypes from 'prop-types';
import { jsx } from '@emotion/core';
import {
  createDayListByWeeks,
  monthsLabels,
  isWeekend,
} from '../../../utils/date';
import { Icon } from '../../ui/Icon';
import { showElementCss } from '../../../utils/responsive';
import { MediaQueries } from '../../../styles/Grid';
import { SafePureComponent } from '../../../utils/SafePureComponent';
import {
  dayButtonCss,
  buttonsContainerCss,
  dayButtonTopLabelCss,
  dayButtonBottomLabelCss,
  sliderCss,
  buttonWidth,
  iconCss,
  leftArrowButtonCss,
  rightArrowButtonCss,
  containerCss,
  innerContainerCss,
  dayButtonSelectedCss,
  selectedLabelCss,
  containerWidth,
} from './index.styles';

class DatePicker extends SafePureComponent {
  static propTypes = {
    date: PropTypes.object,
    weeks: PropTypes.number,
    onChange: PropTypes.func,
    disableWeekends: PropTypes.bool,
    weekends: PropTypes.any
  };

  static defaultProps = {
    date: new Date(),
    weeks: 2,
    onChange: () => {},
    disableWeekends: false,
    weekends: ['0','6'],
  };

  constructor(props) {
    super(props);

    const { date, weeks } = props;

    this.state = {
      daysList: createDayListByWeeks(date, weeks),
      currentPage: 0,
      selectedDayIndex: null,
    };
  }

  static getDerivedStateFromProps(props) {
    const { date, weeks } = props;

    return {
      daysList: createDayListByWeeks(date, weeks),
    };
  }

  getButtonsContainerWidthCss = () => ({
    width: this.props.weeks * 7 * buttonWidth,
  });

  onDayClick = (event, weekDay, index) => {
    event.preventDefault();
    this.setState({ selectedDayIndex: index });
    this.props.onChange(weekDay);
  };

  showPreviousPage = event => {
    event.preventDefault();

    this.setState({ currentPage: Math.max(0, this.state.currentPage - 1) });
  };

  showNextPage = event => {
    event.preventDefault();

    this.setState({
      currentPage: Math.min(this.props.weeks - 1, this.state.currentPage + 1),
    });
  };

  renderDaysList = () => {
    const { daysList } = this.state;
    const { disableWeekends, weekends } = this.props;

    return daysList.map((weekDay, index) => {
      const isDisabled = index === 0 || (disableWeekends && isWeekend(weekDay, weekends));
      const isSelected = index === this.state.selectedDayIndex;
      return (
        <button
          css={[dayButtonCss, isSelected && dayButtonSelectedCss]}
          key={`days-button-${index}`}
          onClick={event => this.onDayClick(event, weekDay, index)}
          disabled={isDisabled}
        >
          <span css={dayButtonTopLabelCss}>{weekDay.day}</span>
          <span css={[dayButtonBottomLabelCss, isSelected && selectedLabelCss]}>
            {monthsLabels[weekDay.month - 1]}
          </span>
        </button>
      );
    });
  };

  safeRender() {
    const { currentPage } = this.state;
    const isLeftArrowDisabled = currentPage === 0;
    const isRightArrowDisabled = currentPage === this.props.weeks - 1;
    const transitionSliderCss = {
      transform: `translateX(${-containerWidth * currentPage}px)`,
    };

    return (
      <div css={containerCss}>
        <div css={innerContainerCss}>
          <button
            onClick={this.showPreviousPage}
            css={[leftArrowButtonCss, showElementCss(MediaQueries.mdAndUp)]}
            disabled={isLeftArrowDisabled}
          >
            <Icon name="chevron-left" customCss={iconCss} />
          </button>
          <div css={sliderCss}>
            <div
              css={[
                this.getButtonsContainerWidthCss(),
                buttonsContainerCss,
                transitionSliderCss,
              ]}
            >
              {this.renderDaysList()}
            </div>
          </div>
          <button
            onClick={this.showNextPage}
            css={[rightArrowButtonCss, showElementCss(MediaQueries.mdAndUp)]}
            disabled={isRightArrowDisabled}
          >
            <Icon name="chevron-right" customCss={iconCss} />
          </button>
        </div>
      </div>
    );
  }
}

DatePicker.displayName = 'DatePicker';

export default DatePicker;
